export default __webpack_public_path__ + "static/media/airdrop.653ea024.svg";